import * as React from "react";
import { BaseBlock, broadcastBlockLoad } from "sb-resp-block-lib";
import { internalMessageBus } from "sb-internal-msg-bus";
import { BaseDict } from "./dict";
import { config } from "./config";
import { AggregatesGamesBlock } from "./ui/AggregatesGamesBlock";
import { AggregatesGamesBlockState } from "./state";
/*
    This structure allows us to use mocks during dev
    but not to include them when we do build:release

    AggregatesDataMock is activated in the AggregatesViewPresenterBlock
    It emits messages on the message bus periodically
    All other blocks' state store subscribe and listen for messages on relevant channels
*/
// import * as MOCKSTYPE from "sb-legacy-integration/lib-esm/mocks";
// let _: typeof MOCKSTYPE;
// let PageMethodsMock;
if (process.env.NODE_ENV === "development") {
    //     _ = require("sb-legacy-integration/lib-esm/mock");
    //     PageMethodsMock = _.PageMethodsMock;
}
export class AggregatesGamesBlockRoot extends BaseBlock {
    // constructor sets defaults
    constructor(domId, options = {
        dict: BaseDict,
        cms: {},
        navHandler: {},
        dataProvider: {},
        betSlipUtil: {},
        oddsUtil: {},
        facade: {},
        gameStatus: {},
        timeControl: {},
        panelId: "",
        storageUtils: {},
        userInfo: {}
    }) {
        super(domId, options);
        if (process.env.NODE_ENV === "development") {
            // setup data mocks for debug build
            this.dataProvider = new AggregatesGamesBlockState(internalMessageBus);
            //export data store to window for debug purposes
            window["AggregatesGamesBlockState"] = this.dataProvider;
        }
        if (process.env.NODE_ENV === "production" && typeof options.dataProvider !== "undefined") {
            // use pagemethods passed during the construction from the
            // mobile application
            this.dataProvider = new AggregatesGamesBlockState(options.dataProvider);
        }
        // if no provided dictionary is not full fill in the missing keys with the base one
        this.options.dict = Object.assign(Object.assign({}, BaseDict), (options.dict || {}));
        // merge default and CMS options
        this.options.cms = Object.assign(Object.assign({}, config), (options.cms || {}));
    }
    activate() {
        this.dataProvider.activate();
        return super.activate(React.createElement(AggregatesGamesBlock, { dataProvider: this.dataProvider, dict: this.options.dict }));
    }
    deactivate() {
        this.dataProvider.deactivate();
        return super.deactivate();
    }
}
window["AggregatesGamesBlock"] = AggregatesGamesBlockRoot;
broadcastBlockLoad("AggregatesGamesBlock");
//# sourceMappingURL=index.js.map